// extracted by mini-css-extract-plugin
export default {"root":"Main_root__Qzh1S","banner":"Main_banner__h3txF","container":"Main_container__1nBTO"};